export const STAGE_KEY = 'scale';

export const STAGE_CONFIG = {
  id: 'fase5',
  label: 'Escalabilidad',
  questionOrder: [
    'requestedService',
    'prospectos',
    'ticket',
    'productionCost',
    'newClients',
    'presupuestoMesa',
    'desiredTimeline',
    'userEmail',
    'userPhone',
  ],
  coreFields: [
    'requestedService',
    'presupuestoMesa',
    'ticket',
    'productionCost',
    'newClients',
    'userEmail',
    'userPhone',
  ],
  serviceIds: ['esc-diagnostico', 'esc-integraciones', 'esc-automatizacion', 'esc-reportes', 'esc-estandarizacion', 'esc-software'],
  questions: {
    requestedService: '¡Mucho gusto, {userName}! Para su escala, ¿que es lo que mas le urge automatizar o integrar hoy mismo en su sistema operativo?',
    prospectos: '¿Y como se reparte hoy el trabajo entre su equipo de marketing, ventas y operaciones? ¿Donde esta el cuello de botella?',
    ticket: 'Para dimensionar la escala ({offer}), ¿cuanto vale en promedio cada cliente que entra a su sistema hoy?',
    productionCost: '¿Cuanto le cuesta hoy atender a ese cliente a nivel de tiempo y herramientas operativas?',
    newClients: '¿Cuantos clientes nuevos deberia estar soportando su operacion por mes sin que nada se rompa?',
    presupuestoMesa: '¿Que presupuesto puede dedicar para ordenar la maquina sin que le apriete la caja mensual?',
    desiredTimeline: '¿En cuanto tiempo necesita estar viendo ya un orden y automatizacion real en su negocio?',
    userEmail: 'Ya casi terminamos. Para mandarle su análisis detallado, ¿a qué correo se lo comparto?',
    userPhone: 'Y por si se corta la conexión antes de darle sus resultados, ¿cuál es su WhatsApp o número de contacto?',
  },
};

const scaleGuide = {
  role: 'Asesor de escalabilidad, automatizacion y tecnologia.',
  detectWhen: [
    'El usuario pide automatizacion, integraciones, CRM, IA, dashboards o software.',
  ],
  firstQuestions: [
    'Que busca exactamente: automatizacion, integraciones, reportes o software?',
  ],
  thenAsk: [
    'Que cuello de botella operativo le frena hoy mas?',
    'Cuanto vale cada cliente en su sistema promedio?',
    'Cuantos clientes nuevos deberia soportar su operacion sin romperse?',
    'Con cuanto presupuesto real cuenta para ordenar la maquina?',
  ],
  avoidForNow: [
    'No empujes software a medida si primero basta con ordenar e integrar.',
  ],
  mustExplain: [
    'Aqui se ordena la maquina para crecer con menos friccion y mas margen.',
  ],
  services: [
    'Diagnostico operativo',
    'Integracion de tecnologias',
    'Automatizacion operativa',
    'Reportes y tableros de control',
    'Estandarizacion de procesos',
    'Software a medida',
  ],
};

export default scaleGuide;
